import React from 'react'
import { Modal } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useEffect } from 'react'

const Opendocumentmodal = ({
  show,
  onClose,
  userId,
  onDocument,
  onUpdate,
  fetchinputs,
  inputData
}) => {
  const [file, setFile] = React.useState(null)
  const [project, setProject] = React.useState('')
  const [projectError, setProjectError] = React.useState('')
  const [wing, setWing] = React.useState('')
  const [wingError, setWingError] = React.useState('')
  const [text, setText] = React.useState('')
  const [fileError, setFileError] = React.useState('')
  const [filteredWings, setFilteredWings] = React.useState([])
  const [textError, setTextError] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const fileInputRef = React.useRef(null)

  useEffect(() => {
    console.log('Modal inputData updated:', inputData)
  }, [inputData])

  const validatefile = event => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      const validateFile = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain'
      ]
      if (validateFile.includes(selectedFile.type)) {
        setFile(selectedFile)
        setFileError('')
      } else {
        setFileError('Invalid file type. Please select a valid file.')
        setFile(null)
      }
    } else {
      setFileError('Please select a file.')
      setFile(null)
    }
  }

  const uniqueProjects = Array.from(
    new Map(
      inputData.map(item => [
        item.projectId,
        { id: item.projectId, name: item.projectName }
      ])
    ).values()
  )

  const validatetext = input => {
    setText(input)
    if (!input || input.trim() === '') {
      setTextError('Text input cannot be empty.')
      return false
    } else {
      setTextError('')
    }
  }

  const handleProjectChange = e => {
    const selectedProjectId = e.target.value
    setProject(selectedProjectId)
    setProjectError('')
    setWing('')

    const wings = inputData.filter(
      item => String(item.projectId) === String(selectedProjectId)
    )

    setFilteredWings(wings)
  }

  const handleWingChange = e => {
    setWing(e.target.value)
    if (e.target.value) setWingError('')
  }

  if (!show) return null

  const handleSubmit = async e => {
    e.preventDefault() 
    let valid = true

    if (!file) {
      setFileError('Image is required')
      valid = false
    }

    if (!text.trim()) {
      setTextError('Text is required')
      valid = false
    }

    if (!valid) return

    setLoading(true)

    const formData = new FormData()
    formData.append('upload', file)
    const uploaddata = await onDocument(formData)
    if (uploaddata) {
      console.log('uploaddata', uploaddata.data)
    }
    const docpayload = {
      ProjectID: project ? parseInt(project) : null,
      Wing: wing || null,
      Data: {
        Title: text,
        DocumentLink: uploaddata
      }
    }

    onUpdate(docpayload)

    if (!fileError && !textError && text.trim() !== '' && file) {
      toast.success('Document created successfully!')
      // Reset form fields
      setFile(null)
      setText('')
      setProject('')
      setWing('')
      setFileError('')
      setTextError('')
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    } else if (!file) {
      setFileError('Please select a valid file before submitting.')
    } else {
      setTextError('Please fill all the fields correctly before submitting.')
    }
    setLoading(false)
  }

  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        centered
        scrollable
        backdrop="static"
        aria-labelledby="document-modal-title"
      >
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="document-modal-title">
                  Create New Documents
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {/* <div className="mb-3 text-bold">
                  <label className="form-label font-bold">
                    Select Project <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={project}
                    onChange={handleProjectChange}
                  >
                    <option value="">Choose Project</option>
                    {uniqueProjects.map(p => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {projectError && (
                    <div className="alert alert-danger mt-2">
                      {projectError}
                    </div>
                  )}
                </div> */}

                {/* File upload */}
                <div className="mb-3">
                  {/* <div className="mb-3 text-bold">
                    <label className="form-label font-bold">
                      Select Wing <span style={{ color: 'red' }}>*</span>
                    </label>
                    <select
                      className="form-control"
                      value={wing}
                      onChange={handleWingChange}
                      disabled={!project}
                    >
                      <option value="">Choose Wing</option>
                      {filteredWings.map(w => (
                        <option key={w.wingId} value={w.wingId}>
                          {w.wingName}
                        </option>
                      ))}
                    </select>
                    {wingError && (
                      <div className="alert alert-danger mt-2">{wingError}</div>
                    )}
                  </div> */}
                  <div className="mb-3 text-bold">
                    <label className="form-label font-bold">
                      Upload File <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={validatefile}
                      ref={fileInputRef}
                    />
                    {fileError && (
                      <div className="alert alert-danger mt-2">{fileError}</div>
                    )}
                  </div>
                  {/* Text input */}
                  <div className="mb-3 text-bold">
                    <label className="form-label font-bold">Enter Text</label>{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Enter text"
                      maxlength="1000"
                      value={text}
                      onChange={e => validatetext(e.target.value)}
                      required
                    />
                  </div>
                  {textError && (
                    <div className="alert alert-danger mt-2">{textError}</div>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
      </Modal>
    </>
  )
}

export default Opendocumentmodal
